import { useEffect, useState } from "react";
import Select from "react-select";
import { Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import { useTranslation } from "react-i18next";

function AddParticipantModal({ isOpen, toggle, employeesData, customersData, participants = [], onSave }) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('employees');
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    const empIds = participants.filter(p => p.type === 'employee').map(p => p.id);
    const custIds = participants.filter(p => p.type === 'customer').map(p => p.id);
    setSelectedEmployees(
      employeesData.filter(e => empIds.includes(e.id)).map(e => ({ value: e.id, label: `${e.firstname} ${e.lastname}` }))
    );
    setSelectedCustomers(
      customersData.filter(c => custIds.includes(c.id)).map(c => ({ value: c.id, label: c.company_name || `${c.firstname} ${c.lastname}` }))
    );
  }, [isOpen]);

  const handleSave = () => {
    const participants = [
      ...selectedEmployees.map(e => ({ id: e.value, type: 'employee' })),
      ...selectedCustomers.map(c => ({ id: c.value, type: 'customer' })),
    ];
    onSave(participants);
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>{t('crm.addParticipant')}</ModalHeader>

      <ModalBody>
        <Nav tabs className="display-tabs">
          <NavItem>
            <NavLink 
              active={activeTab === 'employees'}
              onClick={() => setActiveTab('employees')}
            >
              {t('sidebar.employees')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              active={activeTab === 'customers'}
              onClick={() => setActiveTab('customers')}
            >
              {t('crm.customers')}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} className="border-0 py-2 px-0">
          <TabPane tabId="employees">
            <Select 
              options={employeesData.map(employee => ({ value: employee.id, label: `${employee.firstname} ${employee.lastname}` }))}
              styles={SelectCustomStyles}
              isMulti
              value={selectedEmployees}
              onChange={setSelectedEmployees}
            />
          </TabPane>
          <TabPane tabId="customers">
            <Select 
              options={customersData.map(customer => ({ value: customer.id, label: customer.company_name || `${customer.firstname} ${customer.lastname}` }))}
              styles={SelectCustomStyles}
              isMulti
              value={selectedCustomers}
              onChange={setSelectedCustomers}
            />
          </TabPane>
        </TabContent>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton color="primary" size="sm" onClick={handleSave}>{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default AddParticipantModal;